/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface DayAvailability
 */
export interface DayAvailability {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof DayAvailability
     */
    day: DayAvailabilityDayEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DayAvailability
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof DayAvailability
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof DayAvailability
     */
    end: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DayAvailabilityDayEnum {
    Monday = 'monday',
    Tuesday = 'tuesday',
    Wednesday = 'wednesday',
    Thursday = 'thursday',
    Friday = 'friday',
    Saturday = 'saturday',
    Sunday = 'sunday'
}

